<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('paymentPool.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="paymentPoolInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="paymentPoolInfo.conditions.paymentName" :placeholder="$t('paymentPool.selectName')"
                clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="paymentPoolInfo.conditions.paymentType"
                :placeholder="$t('paymentPool.selectPaymentVendor')" style="width:100%" clearable>
                <el-option v-for="(item, index) in paymentPoolInfo.paymentTypes" :key="index" :label="item.name"
                  :value="item.paymentType" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="paymentPoolInfo.conditions.state" :placeholder="$t('paymentPool.selectStatus')"
                style="width:100%" clearable>
                <el-option :label="$t('paymentPool.enable')" value="Y" />
                <el-option :label="$t('paymentPool.disable')" value="N" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryPaymentPoolMethod()">
              <i class="el-icon-search"></i>
              {{ $t('paymentPool.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('paymentPool.paymentConfig') }}</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddPaymentPoolModal()">
          {{ $t('paymentPool.add') }}
        </el-button>
      </div>
      <div class="card-body">
        <el-table :data="paymentPoolInfo.paymentPools" border style="width: 100%">
          <el-table-column prop="paymentName" :label="$t('paymentPool.name')" align="center" />
          <el-table-column prop="paymentTypeName" :label="$t('paymentPool.paymentVendor')" align="center" />
          <el-table-column :label="$t('paymentPool.paymentScope')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.payType === '1001'">{{ $t('paymentPool.communityFee') }}</span>
              <span v-else-if="scope.row.payType === '2002'">{{ $t('paymentPool.tempCarFee') }}</span>
              <span v-else>{{ $t('paymentPool.specifiedFee') }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('paymentPool.status')" align="center">
            <template slot-scope="scope">
              {{ scope.row.state === 'Y' ? $t('paymentPool.enable') : $t('paymentPool.disable') }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('paymentPool.createTime')" align="center" />
          <el-table-column prop="remark" :label="$t('paymentPool.usageInstructions')" align="center" />
          <el-table-column :label="$t('paymentPool.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="_openEditPaymentPoolModel(scope.row)">
                {{ $t('paymentPool.edit') }}
              </el-button>
              <el-button type="text" size="small" @click="_openDeletePaymentPoolModel(scope.row)">
                {{ $t('paymentPool.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="paymentPoolInfo.conditions.page" :page-size="paymentPoolInfo.conditions.row"
          :total="paymentPoolInfo.total" layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <add-payment-pool ref="addPaymentPool" @refresh="_listPaymentPools" />
    <edit-payment-pool ref="editPaymentPool" @refresh="_listPaymentPools" />
    <delete-payment-pool ref="deletePaymentPool" @refresh="_listPaymentPools" />
  </div>
</template>

<script>
import { listPaymentPool, listPaymentAdapt } from '@/api/frame/paymentPool/paymentPoolApi'
import { getShopId } from '@/api/shop/shopApi'
import AddPaymentPool from '@/components/frame/addPaymentPool/addPaymentPool.vue'
import EditPaymentPool from '@/components/frame/editPaymentPool/editPaymentPool.vue'
import DeletePaymentPool from '@/components/frame/deletePaymentPool/deletePaymentPool.vue'

export default {
  name: 'PaymentPool',
  components: {
    AddPaymentPool,
    EditPaymentPool,
    DeletePaymentPool
  },
  data() {
    return {
      paymentPoolInfo: {
        paymentPools: [],
        paymentTypes: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          paymentName: '',
          paymentType: '',
          state: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this._loadListPaymentAdapt()
    this._listPaymentPools()
  },
  methods: {
    async _listPaymentPools() {
      let shopId = getShopId();
      this.paymentPoolInfo.conditions.shopId = shopId
      try {
        const res = await listPaymentPool(this.paymentPoolInfo.conditions)
        this.paymentPoolInfo.total = res.total
        this.paymentPoolInfo.records = res.records
        this.paymentPoolInfo.paymentPools = res.data
      } catch (error) {
        console.error('获取支付配置列表失败:', error)
      }
    },
    async _loadListPaymentAdapt() {
      try {
        const res = await listPaymentAdapt({ page: 1, row: 100 })
        this.paymentPoolInfo.paymentTypes = res.data
      } catch (error) {
        console.error('获取支付类型失败:', error)
      }
    },
    _openAddPaymentPoolModal() {
      this.$refs.addPaymentPool.open()
    },
    _openEditPaymentPoolModel(paymentPool) {
      this.$refs.editPaymentPool.open(paymentPool)
    },
    _openDeletePaymentPoolModel(paymentPool) {
      this.$refs.deletePaymentPool.open(paymentPool)
    },
    _queryPaymentPoolMethod() {
      this.paymentPoolInfo.conditions.page = 1
      this._listPaymentPools()
    },
    handleCurrentChange(val) {
      this.paymentPoolInfo.conditions.page = val
      this._listPaymentPools()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>